export default {
  buttons: {
    save: 'Guardar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  confirmation: {
    title: 'Tem a certeza de que pretende sincronizar com os serviços externos?',
  },
};
